<template>
  <div>
    <v-dialog v-model="isOpenDialog" width="700px" class="color" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title
            >CHI TIẾT HÓA ĐƠN {{ !kind ? '' : kind === 'cen' ? 'HỌC PHÍ' : 'THU HỘ / CHI HỘ' }}</v-toolbar-title
          >
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-card-text id="element-to-convert">
          <InfoStudentBill />
          <DetailBillByStudent :kind="kind" :canInteract="canInteract" />
          <!-- <InfoBankAccountTeacher v-if="kind !== 'cen'" /> -->

          <div class="summary_wrap" v-if="detailPeriod.status !== 'created'">
            <div class="summary_final">
              <p>Tổng kết cuối:</p>
              <span>{{ calculateAt }}</span>
            </div>
            <div class="summary_people">
              <p>Người tổng kết:</p>
              <span>{{ detailPeriod.generatedBy ? detailPeriod.generatedBy.name : '' }}</span>
            </div>
          </div>
          <div v-if="detailPeriod.index != 7 && kind === 'cen'">
            <div class="summary_people">
              <p>Số tiền đã nộp:</p>
              <span>{{ get(report[kind], 'amountPaid', 0) | price }}</span>
            </div>
            <div v-if="get(report[kind], 'check.createdAt', '') != ''" class="summary_people">
              <p>Đối soát lúc:</p>
              <span>{{ formatDate(get(report[kind], 'check.createdAt', '')) }}</span>
            </div>
            <div v-if="kind === 'cen'" class="summary_people">
              <p>Tài khoản định danh:</p>
              <span>{{ report.customerId | getCustomerId }}</span>
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="mt-5" v-if="canInteract">
          <v-btn
            v-if="$auth.policies['summary-period']"
            depressed
            color="primary"
            class="px-6 ml-2 mt-n4 mb-2 white--text"
            @click="summarizing()"
            >TỔNG KẾT LẠI</v-btn
          >
          <v-spacer />
          <v-btn depressed color="primary" class="px-6 mr-2 mt-n4 mb-2 white--text d-none" @click="exportToPDF()"
            >XUẤT FILE PDF</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import html2pdf from 'html2pdf.js'
import DetailBillByStudent from './DetailBillByStudent.vue'
// import InfoBankAccountTeacher from './InfoBankAccountTeacher.vue'
import InfoStudentBill from './InfoStudentBill.vue'
import { get } from 'lodash'
import moment from 'moment'
export default {
  components: {
    InfoStudentBill,
    DetailBillByStudent
    // InfoBankAccountTeacher,
  },
  props: {
    canInteract: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpenDialog: false,
      loading: false,
      kind: null,
      get
    }
  },
  filters: {
    getCustomerId(customerId) {
      if (typeof customerId === 'string' && customerId.length) {
        if (customerId.startsWith('8LTV')) return customerId
        return 'V5LTVHP' + customerId
      }
      return '---'
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      report: 'tuitionFeeReport/report'
    }),
    calculateAt() {
      const calculateAt = get(this.report, `${this.kind}.calculateAt`, '')
      if (typeof calculateAt === 'string' && calculateAt.length) return this.$options.filters.ddmmyyyyhhmm(calculateAt)
      const periodCalculateAt = get(this.detailPeriod, 'updatedAt', '')
      if (typeof periodCalculateAt === 'string' && calculateAt.length)
        return this.$options.filters.ddmmyyyyhhmm(periodCalculateAt) + ` (theo kỳ đóng)`
      return '-'
    }
  },
  methods: {
    ...mapActions('tuitionFeeReport', ['summarizingEachStudent', 'fetchOne']),
    async openDialog(kind) {
      this.$loading.active = true
      await this.fetchOne(this.report.id)
      this.$loading.active = false
      this.isOpenDialog = true
      this.kind = kind
    },
    cancel() {
      this.isOpenDialog = false
    },
    exportToPDF() {
      let convertFullDate = this.$options.filters.convertFullDate(this.detailPeriod.title)
      html2pdf(document.getElementById('element-to-convert'), {
        filename: `${this.report.student.name}_${this.report.student.code.substr(0, 5)}_${convertFullDate}.pdf`
      })
    },
    formatDate(isoString) {
      return moment(isoString).format('HH:mm DD/MM/YYYY')
    },
    summarizing() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết lại?',
        text:
          'Các thông tin cũ trong hóa đơn có thể bị thay đổi và<br/>không thể hoàn tác. Bạn có chắc chắn muốn tổng kết lại hóa đơn cho học sinh này',
        cancelText: 'Hủy',
        okText: 'Xác nhận',
        done: async () => {
          try {
            this.$loading.active = true
            await this.summarizingEachStudent({
              studentId: this.report.student.id,
              periodId: this.detailPeriod.id,
              kind: this.kind
            })
            this.$alert.success('Đã tổng kết lại thành công!')
          } catch (e) {
            let msg = {
              title: 'Lỗi thao tác',
              description: 'Hệ thống đang thực hiện tổng kết. Vui lòng chờ.'
            }
            if (e === 'Connection fail') {
              msg = {
                title: 'Lỗi kết nối',
                description: 'Không thể thực hiện tổng kết. Vui lòng thử lại.'
              }
            }
            this.$alert.error({ title: msg.title, description: msg.description })
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
#element-to-convert {
  font-family: 'Roboto';
}

.margin {
  margin: 10px 0;
}

.summary_wrap > .summary_final,
.summary_people {
  display: flex;
  margin: 12px 12px 12px 20px;
}

.summary_wrap > .summary_final p,
.summary_people p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 8px 0 0;
}

.total_money {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.total_money h3,
.total_money span {
  color: #fd6b6b;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
</style>
